// Geotab Partner Domain Configuration
export const geotabpartnerConfig = {
  // Basic domain information
  id: 'geotabpartner',
  name: 'Geotab Partner',
  tagline: 'Partner with Geotab',
  description: 'Complete fleet management solutions and equipments store.',
  
  // Assets
  logo: '/assets/logos/geotabpartner-logo.png',
  whiteLogo: '/assets/logos/geotabpartner-white-logo.png',
  favicon: '/assets/favicons/geotabpartner-favicon.png',
  icon: '/assets/icons/geotabpartner',
  
  // Navigation
  pages: ['home', 'solutions', 'products', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Products', path: '/products' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy Now'
  },
      
  // Shop link
  shopLink: 'https://shop.fleethoster.com/collections/geotab',

  // UI Configuration
  variant: 'clean',
  showFeatures: true,
  showTestimonials: true,
  
  // Content sections
  hero: {
    title: 'Geotab Partner - One platform for optimal fleet performance',
    subtitle: 'Find everything you need for your fleet in one place. From cameras to tracking devices, we have it all.',
    features: ['Connect your entire fleet, seamlessly', 'Unlock fleet potential with AI-powered insights', 'Drive safety, efficiency, and savings']
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'Geotab Partner Solutions',
    subtitle: 'Explore our comprehensive fleet management and equipment solutions',
    description: 'See how Geotab Partner transforms fleet operations with integrated technology'
  },

  features: {
    title: 'Geotab Partner Features',
    subtitle: 'Your Fleet Equipment Solutions',
    description: 'Complete fleet equipment and accessories solutions with comprehensive solutions for all your needs by Geotab.',
    items: [
        {
          title: 'Fleet dash cams',
          description: 'Take the guesswork out of collisions and other critical traffic events with our seamlessly integrated AI-powered dash camera solutions',
          icon: '📹'
        },
        {
          title: 'Asset tracking',
          description: 'Gain peace of mind knowing where all your high valued assets are.',
          icon: '👨‍💼'
        },
        {
          title: 'ELD',
          description: 'Our FMCSA-certified ELD automates data collection and provides step-by-step workflows with pop-up reminders to minimize violations.',
          icon: '🚚'
        },
        {
          title: 'Routing and dispatching',
          description: 'Improve productivity and help lower costs by leading your fleet down the right path with our fleet routing and dispatching solutions.',
          icon: '🛡️'
        },
      ]
  },
  
  solutions: {
    title: 'Fleet optimization Solutions provided by Geotab Partner',
    subtitle: 'Use data-driven insights to optimize fleet performance. ',
    description: 'Geotab and Geotab Partner offer a wide range of solutions to help you optimize your fleet performance. From driver tracking to fleet maintenance, we have you covered.',
    sections: [
      {
        title: 'Driver Tracking',
        description: 'Improve driver behavior with our robust suite of driver tracking and coaching tools. Find the productivity solutions that are right for your business. From scorecards and trend reports to collision avoidance systems, you can customize our solutions to fit your business and fleet.'
      },
      {
        title: 'Geotab GO Anywhere Asset Tracking System',
        description: "Geotab GO Anywhere Asset Trackers enable companies to efficiently manage and track their critical assets using the same platform they use for their fleet vehicles, all at an affordable cost. Geotab's asset tracking solutions are scalable and designed for businesses of all sizes,  offering you visibility into your assets' location and availability. "
      },
      {
        title: 'Geotab Keyless',
        description: 'Enjoy fleet optimization at every level. Save time and costs with Geotab Keyless — a solution offering secured vehicle access for pooled and shared fleets, even when vehicles are parked out of cellular coverage.'
      },
      {
        title: 'Fleet fuel management',
        description: "Monitor and control your fleet performance and fuel consumption. Set rules and alerts to improve routing and manage speeding and idling time. Use reports and driver training tools to develop fuel-efficient driving behaviors."
      },
      {
        title: 'Fleet maintenance',
        description: "Stay ahead of the curve with automated reminders and integrated solutions for fleet performance and maintenance. Easily identify and prioritize maintenance tasks early on to help prevent vehicle wear and reduce downtime."
      },
      {
        title: 'Fleet benchmarking',
        description: "Turn your data into a business advantage and deliver measurable results to your business with our fleet benchmarking tools. Gain fleet-specific recommendations, find new efficiencies and uncover gaps by comparing your fleet to similar fleets."
      },
      {
        title: 'EV battery life and range',
        description: 'Maximize the value of your electric vehicles with essential reports and alerts that provide insight into real battery capacity and range, battery degradation, charging status and more. Align routes to range and know when it\'s time to replace EVs.'
      },
    ]
  },

  testimonials: [
    {
      content: "I don't know how we'd do it without Geotab – the solution is literally in every aspect of our operations.",
      author: "Jonathan Hamilton",
      role: "Director of Fleet Safety and Compliance",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/25.jpg"
    },
    {
      content: "We're excited about what's coming next. It just keeps getting better and better, working with their technology and continuing to evolve. It's been great.",
      author: "Christian Reisch",
      role: "Co-owner",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/26.jpg"
    }
  ],
  
  // Products
  products: {
    title: 'Our Partner\'s Products',
    subtitle: 'Discover our comprehensive range of fleet management cameras, equipments and accessories designed to optimize your operations.',
    categories: [
      { id: 'all', name: 'All Products' },
      { id: 'cameras', name: 'Cameras' },
      { id: 'trackers', name: 'Trackers' },
      { id: 'aux', name: 'Auxiliary' },
      { id: 'power', name: 'Power' },
      { id: 'harnesses', name: 'Harnesses' },
      { id: 'monitor', name: 'Monitors' },
    ],
    items: [
      {
        id: 1,
        title: 'Geotab GO9 Device',
        description: 'Advanced telematics device with 4G connectivity, GPS tracking, and comprehensive vehicle diagnostics.',
        brand: 'Geotab',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/vtd12-go9',
        image: 'product-1',
        featured: true,
        details: [
          {
            title: 'Precise GPS tracking',
            description: 'Collect precise data on vehicle location, speed, trip distance and time, engine idling and more with the GO9. Even if you park a vehicle indoors and underground, advanced GPS vehicle tracking and telematics starts recording as soon as you begin driving. The GO9 introduces the new Global Navigation Satellite System module (GNSS) for faster latch times and increasingly accurate location data.',
            features: []
          },
          {
            title: 'Vehicle health assessments',
            description: 'Extract valuable vehicle health information within our fleet vehicle tracking system. Capture and record the vehicle identification number (VIN), odometer reading, engine faults and more. This data helps you prioritize vehicle fleet maintenance and audit vehicle use to identify both safe and risky driving behaviors.',
            features: []
          },
          {
            title: 'Collision detection and notification',
            description: 'GO9 offers harsh-event data (such as aggressive acceleration, harsh braking or cornering) and collision reconstruction through its accelerometer and our patented algorithms. If GO9 detects a suspected collision, it will automatically upload detailed data that enables forensic reconstruction of the event. This includes in-vehicle reverse collisions. Email and desktop alerts signal the first notice of loss.',
            features: []
          },
          {
            title: 'Secured data',
            description: 'Geotab uses authentication, encryption and message integrity verification for GO9 vehicle tracking devices and network interfaces. Each GO9 device uses a unique ID and non-static security key, making it difficult to fake a device’s identity. Over-the-air (OTA) updates use digitally signed firmware to verify that updates come from a trusted source.',
            features: []
          },
          {
            title: 'In-vehicle driver coaching',
            description: 'Improve driving behaviors, such as following speed limits and reducing idling time, by playing an audible alert. GO9 also enables you to coach the driver with spoken words (available as an Add-On). Immediate driver feedback can enhance fleet safety, reinforce company policy and encourage your drivers to take immediate corrective action.',
            features: []
          },
          {
            title: 'Advanced data capture',
            description: 'Vehicles send data from a multitude of sources, including the engine, drivetrain, instrument cluster and other subsystems. Utilizing multiple internal networks, the GO9 captures and organizes much of this data.',
            features: []
          }
        ]
      },
      {
        id: 2,
        title: 'Geotab GO Focus Plus',
        description: 'AI Camera Model with built-in speaker and microphone for in-cabin alerts and coaching.',
        brand: 'Geotab',
        category: 'cameras',
        productLink: 'https://shop.fleethoster.com/products/dcc12-gofocus-plus',
        image: 'product-2',
        featured: true,
        details: [
          {
            title: 'Less Friction',
            description: '',
            features: [
              'Automatic device detection and pairing',
              'Self-calibrating to eliminate the hassle',
            ]
          },
          {
            title: 'Real intelligence',
            description: '',
            features: [
              'Less false positives',
              'Enhanced coaching with AI',
            ]
          },
          {
            title: 'Driver centric',
            description: '',
            features: [
              'Proactive collision management',
              'Privacy first design',
            ]
          },
          {
            title: 'All-in-one video telematics and safety platform',
            description: '',
            features: [
              'Driver risk scores',
              'Driver risk change',
              'Severity-based event review',
              'Coaching sessions',
              'Coaching automation',
              'Full event context'
            ]
          }
        ]
      },
      {
        id: 3,
        title: 'Geotab GO9 RUGGED',
        description: 'a ruggedized telematics device that offers GPS technology, g-force monitoring, Geotab IOX expandability, engine and battery health assessments, and the ability to communicate on the LTE network.',
        brand: 'Geotab',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/atw12-0',
        image: 'product-3',
        featured: false,
        details: [
          {
            title: 'Vehicle tracking',
            description: 'Using Geotab’s patented tracking algorithm, the GO9 RUGGED accurately recreates vehicle trips and analyzes incidents. The GO9 RUGGED also offers in-vehicle alerts to instantly notify drivers of infractions and — with hardware Add-Ons — provides live coaching for driver’s on-road performance. The GO9 RUGGED does not require a dash-mounted antenna or any wire splicing.',
            features: []
          },
          {
            title: 'Security',
            description: 'Geotab platform security is designed for end-to-end protection of your data.',
            features: [
              'GO devices and network interfaces use authentication, encryption, and message integrity verification.',
              'GO devices are individualized. Each device uses a unique ID and non-static security key, making it difficult to fake a device’s identity.',
              'Over-the-air updates use digitally-signed firmware to verify that updates come from a trusted source.',
              'Geotab uses independent third-party experts to validate the platform from end-to-end.',
              'FIPS 140-2 validated firmware module used for performing cryptography (certificate #3371).'
            ]
          },
          {
            title: 'Key features',
            description: '',
            features: [
              'IP68 & IP69K rated for water, dust ingress and pressure spray protection',
              'LTE connectivity',
              'Simple device design for covert installations',
              'Intelligent in-vehicle driver coaching',
              'Breakthrough collision detection and notification',
              'External device expandability via IOX Technology',
            ]
          },
          {
            title: '...and more',
            description: '',
            features: [
              'Built-in auto-calibrating accelerometer and gyrometer',
              'Near-real-time vehicle data',
              'Fast GPS acquisition time using Almanac OTA support',
              'Support for GPS+GLONASS connectivity',
              'Additional native support for more vehicle protocols',
              'End-to-end cybersecurity',
            ]
          }
        ]
      },
      {
        id: 4,
        title: 'FleetFlix AI+ Pro Camera',
        description: 'AI-powered driver monitoring solution designed to detect distracted driving, drowsiness, and smartphone usage.',
        brand: 'FleetFlix',
        category: 'cameras',
        productLink: 'https://shop.fleethoster.com/products/dcc01-ffproa',
        image: 'product-4',
        featured: true,
        details: [
          {
            title: 'AI-powered driver monitoring solution (DMS)',
            description: 'Dual 1080P front and interior cameras and processes video footage to provide real-time warnings and feedback to drivers.',
            features: [
              'Live View',
              'OBD2 cabling',
              'GPS',
              'Notifications',
              'Full integration with Geotab'
            ]
          },
          {
            title: 'KEY HARDWARE FEATURES',
            description: '',
            features: [
              'Dual 1080P cameras (front and rear)',
              'AI-powered driver monitoring',
              'Removable micro SD card storage (up to 256GB)',
              'Detection of smartphone usage, drowsiness, and fatigue',
              'Supports additional inputs/outputs',
            ]
          },
          {
            title: 'Product Specifications',
            description: '',
            features: [
              'Dimensions - 4.05 in × 1.77 in × 1.37 in (103 mm × 45 mm × 35 mm)',
              'Weight - 2.82 oz (0.176 lbs) (80 g)',
              'AI-powered driver monitoring',
              'Operating Temperature - -20°C to 70°C (-4°F to 158°F)',
              'Storage Temperature - -30°C to 80°C (-22°F to 176°F)',
              'Power Supply - 5V/2A',
              'Storage - Micro SD card (up to 256GB)',
            ]
          }
        ]
      },
      // {
      //   id: 5,
      //   title: 'Fleetflix LITE PRO Dual Dash Camera',
      //   description: 'AI-powered solution designed for fleet management',
      //   brand: 'FleetFlix',
      //   category: 'cameras',
      //   image: 'product-5',
      //   featured: true,
      //   details: [
      //     {
      //       title: 'AI-powered solution',
      //       description: 'The AI-powered solution that not only enhances driver safety but also takes fleet management efficiency to the next level. This advanced dual dash camera is designed to proactively reduce traffic accidents and promote safer driving practices.',
      //       features: []
      //     },
      //     {
      //       title: 'Cutting-edge AI technology',
      //       description: 'FleetFlix LITE PRO+ actively detects risky driving events and unsafe behaviors, delivering real-time reminders to drivers on the road. This not only mitigates potential risks but also acts as a valuable tool for driver training. The camera seamlessly uploads events to the fleet management platform, providing a comprehensive overview for strategic decision-making.',
      //       features: []
      //     },
      //     {
      //       title: 'Product Features',
      //       description: '',
      //       features: [
      //         'Ultra-wide 143° road facing lens, up to 1920p uhd video recording',
      //         'Ultra-wide 170° driver facing lens, up to 1080p hd video recording',
      //         'Up to 1tb of storage, utilizing 2 x 512gb dual-micro sd cards for continuous or backup',
      //         '4-channel io input, 1-channel can and i-channel rs232',
      //         'Built-in adas function, lane departure warning (ldw), forward collision warning (fcw), and headway monitoring warning (hmw)',
      //         'Built-in dms function, supporting detection of unsafe driving behaviors: lens covered, yawning, handheld devices, smoking, distraction, no driver, unfasten seat belt',
      //         'Sleep mode remote wakeup',
      //         'Built-in g-axis gravity sensor support rapid acceleration, rapid deceleration, harsh cornering, accident detection',
      //         'Fully integrated into geotab',
      //       ]
      //     },
      //     {
      //       title: 'Product Specifications',
      //       description: '',
      //       features: [
      //         'Dimensions - 4.44 in × 2.66 in × 3.46 in (113 mm × 68 mm × 88 mm)',
      //         'Weight - 10.4 oz (295 g)',
      //         'Operating Temperature - -40°F to +158°F (-40°C to +70°C)',
      //         'Power Supply - 12V and 24V vehicles',
      //         'Wifi - Supports 2A6',
      //         'Video Recording - Up to 4 Channel',
      //         'Connectivity - LTE FDD B2/B4/B5/B12/B13/B14/B66/B7, WCDMA B2/B4/B5',
      //       ]
      //     }
      //   ]
      // },
      // {
      //   id: 6,
      //   title: 'FleetLix Lite Road Facing Dash Camera',
      //   description: 'Your go-to solution for optimizing fleet management. This cutting-edge dashcam is designed to empower driver privacy and streamline fleet operations, enhancing overall efficiency.',
      //   brand: 'FleetFlix',
      //   category: 'cameras',
      //   image: 'product-6',
      //   featured: false,
      //   details: [
      //     {
      //       title: 'Introducing',
      //       description: 'FleetLix Lite goes beyond traditional dashcams, offering real-time and precise vehicle position information along with comprehensive operational data transmitted directly to the fleet management platform. Stay in control with instant access to crucial insights, allowing for informed decision-making and optimal resource allocation.',
      //       features: []
      //     },
      //     {
      //       title: 'Live Streaming',
      //       description: 'FleetLix Lite with high-quality live streaming functionality, FleetLix Lite fosters seamless communication between drivers and the fleet management team. Experience the convenience of video live view playback, making it easier than ever to review and analyze events on the road.',
      //       features: []
      //     },
      //     {
      //       title: 'Product Features',
      //       description: '',
      //       features: [
      //         'Ultra-wide 143° road facing lens, up to 1920p uhd video recording',
      //         'Up to 1tb of storage, utilizing 2 x 512gb dual-micro sd cards for continuous or backup',
      //         '2 channel video recording',
      //         '4-channel IO input, 1-channel CAN and 1-channel RS232',
      //         'Built-in Wi-Fi, 4G communication module, and inertial navigation positioning module',
      //         'Compact design that doesn\'t affect the driver\'s sight',
      //         'OBD plug-in play installation',
      //         'Sleep mode remote wakeup',
      //         'Supports rapid acceleration, rapid deceleration, harsh cornering, and accident detection',
      //         'Fully integrated into geotab',
      //       ]
      //     },
      //     {
      //       title: 'Product Specifications',
      //       description: '',
      //       features: [
      //         'Dimensions - 4.4 in x 2.66 in x 2.24 in (113.0 mm x 67.8 mm x 57 mm)',
      //         'Weight - 0.584 lbs (265 g)',
      //         'Operating Temperature - -40°F to +158°F (-40°C to +70°C)',
      //         'Power Supply - 12V and 24V Vehicles',
      //         'WiFi - Supports 2.4G',
      //         'IP Rating - IP30',
      //         'Connectivity - 4G LTE FDD: B2/B4/B5/B12/B13/B14/B66/B71, WCDMA: B2/B4/B5'
      //       ]
      //     }
      //   ]
      // },
      {
        id: 7,
        title: 'Surfsight AI-12 DCC07-12',
        description: 'The DCC07-12 brings you the most advanced reporting features currently available in the video dash camera market.',
        brand: 'Surfsight',
        category: 'cameras',
        productLink: 'https://shop.fleethoster.com/products/dcc07-12',
        image: 'product-7',
        featured: false,
        details: [
          {
            title: 'Introducing',
            description: 'Now with DCC07-12 you can set up rules inside of your database that manage events and video for you! Maybe you don’t want videos downloaded anytime a vehicle goes 10mph over the posted speed limit. Set a rule to note it but not download the video. Furthermore, you can create a rule for detected collision to automatically record 10 seconds before and after the event and automatically download videos you want. It’s all about efficiency for your staff and data (both can be costly). You want live video to protect your company accurately and efficiently—this DCC07-12 kit gives exactly that!',
            features: []
          },
          {
            title: 'What makes this system special?',
            description: '',
            features: [
              'Live streaming',
              'IR night-vision',
              'Distracted driver detection',
              'Wi-Fi hotspot connectivity for up to 4 additional wireless cameras',
              'Driver coaching feature',
              'A.I.-ready',
              'Panic button',
              'Tamper detection', 
              'Built-in storage and cloud storage',
              'Parking mode',
              'SIM and SD card lock',
              'Over-the-air upgrades',
              '10-minute installation',
              'Integrated into Geotab'
            ]
          },
          {
            title: 'Hardware Features',
            description: '',
            features: [
              'Adjustable event/trigger setting levels to get videos when you want them',
              'Parking mode allows you to record an event even with ignition off',
              'Automatic server upload based on events prevents driver tampering of SD card',
              'Can be used as both GPS telematics device & dashcam in one sleek device',
              'Integrated into Geotab so any vehicle rule can trigger a video event from camera'
            ]
          },
          {
            title: 'Product Specifications',
            description: '',
            features: [
              'Live stream, Dual IR, Distracted Driver detect, WiFi hotspot connectivity for more cameras',
              'Forward & Rear facing dual cam w/ IR + Optional cameras for WiFi expandability',
              'Live Stream, Event-based, 30-day backup',
              'Input Voltage - 5V 2amp',
              'Operating Temperature - -10°C to +85°C (14°F to +185°F)',
              'Hardwire or OBD2 plug & play',
              'HD 1080p road facing',
              '720p driver facing',
            ]
          }
        ]
      },
      {
        id: 8,
        title: 'Asset Tracker Solar ATS01-96',
        description: 'Solar-powered GPS tracking device designed to track trailers, trucks, containers, and heavy-duty construction equipment.',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/ats01-96',
        image: 'product-8',
        featured: false,
        details: [
          {
            title: 'Product Description',
            description: '',
            features: [
              'Monitors temperature, humidity, door status, and more with BLE 5.0.',
              'Rugged, durable, and can report frequently for long periods.',
              'Solar panel has a long-life battery that can last for months without solar power charging.',
              'Easy installation with no wiring or cabling required.',
            ]
          },
          {
            title: 'Hardware Features',
            description: '',
            features: [
              'Variable reporting intervals for real-time updates several times per day',
              'Can buffer up to 60,000 location points when out of network coverage',
              'Rugged and weatherproof design for outdoor use',
              'Automatically recharges itself in sunlight',
              'Tamper alert sensor if removed from asset',
              'Additional BLE 5.0 capability to track temperature, humidity, door sensors and more',
              'Fully integrated into Geotab',
            ]
          },
          {
            title: 'Product Specifications',
            description: '',
            features: [
              'Dimensions: 85mm × 185mm × 31mm',
              'Operating Temperature: -25°C to +70°C (-13°F to 158°F)',
              'Weight: 370g (13.05oz)',
              'Battery: Rechargeable Li 9600 mAh / 3.6V',
              'Alerts/Sensors: Tamper Alert, BLE 5.0 / IP65 Sensors',
              'IP/Ingress Rating: IP67',
              'Mounting/Install Options: Magnet / Zip-tie / Screws',
              'Network Connectivity: 4G LTE Cat M1',
              'Bands: B1, B2, B3, B4, B5, B8, B12, B13, B18, B19, B20, B26, B28A/B28B, B39'
            ]
          }
        ]
      },
      {
        id: 9,
        title: 'DCA01-FFLITE-RC-AHD Aux Cam',
        description: 'FleetFlix Lite auxiliary cameras that connect to FleetFlix Lite and FleetFlix Lite Pro+ dashcams, providing 360° video coverage with HD recording from multiple vehicle perspectives.',
        brand: 'FleetFlix',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-fflite-rc-ahd',
        image: 'product-9',
        featured: false,
        details: [
          {
            title: 'Product Description',
            description: 'FleetFlix Lite auxiliary cameras are connected to FleetFlix Lite and FleetFlix Lite Pro+ dashcams. When connected to the dash camera, the cameras enable live video and recording from additional perspectives during trips. The cameras are installed around the vehicle in key locations (side and rear). All auxiliary cameras include a high-definition 1920×1080 lens, auto gain, 3D noise reduction, and backlight compensation. They provide 360° video coverage for the fleet.',
            features: []
          },
          {
            title: 'Key Features',
            description: '',
            features: [
              'Image sensor: 1/2.8" 2.13M pixel CMOS',
              'Resolution: 1920H × 1080V',
              'Minimum illumination: 0LUX (IR on); 0.05LUX (IR off)',
              'Auto electronic shutter, auto exposure, and auto white balance',
              'IR range: 10M (12 Q5 850NM LED dots)',
              'IP rating: IP67',
              'Includes a 0.5M waterproof aviation cable, DC12V black shell',
              'White balance auto tracking'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Signal-to-noise ratio: ≥50dB',
              'Electronic shutter speed: 1/25s ~ 1/25,000s (auto)',
              'Day/night mode: ICR IR filter',
              'Operating temperature: -40°C to +70°C',
              'Operating humidity: <95% (no condensation)',
              'Power supply: DC12V ±10%',
              'Dimensions: 3 in × 2.5 in × 2.9 in (75mm × 65.1mm × 73.7mm)',
              'Weight: 0.6 lbs (280g)',
              'Power consumption: ~130mA / DC12V ±5%'
            ]
          },
          {
            title: 'Lens Options',
            description: '',
            features: [
              '2.5mm M12@ F2.0; HFOV: 123°, VFOV: 69°, DFOV: 141°',
              '2.8mm M12@ F2.0; HFOV: 103°, VFOV: 56°, DFOV: 121°',
              '3.6mm M12@ F2.2; HFOV: 88°, VFOV: 49°, DFOV: 103°',
              'Other lens options with varying fields of view available',
              'Composite video output at various specifications'
            ]
          }
        ]
      },
      {
        id: 10,
        title: 'DCA01-FFLITE-SC-CA39-AHD Aux Cam',
        description: 'High-definition auxiliary camera compatible with FleetFlix Lite systems, offering 360° video coverage with advanced features like auto gain and 3D noise reduction.',
        brand: 'FleetFlix',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-lite-sc-ahd',
        image: 'product-10',
        featured: false,
        details: [
          {
            title: 'Product Description', 
            description: 'FleetFLIX Lite auxiliary cameras are connected to FleetFLIX Lite and FleetFLIX Lite Pro+ dashcams. When connected to the dash camera, the cameras enable live video and recording from the portal of additional perspectives during trips. The cameras are installed around the vehicle in key locations (side and rear). All auxiliary cameras include a high-definition 1920×1080V lens. Auto gain, 3D noise reduction, and backlight compensation are all supported. Provide your fleet with 360° video coverage.',
            features: []
          },
          {
            title: 'Key Features',
            description: '',
            features: [
              'Image sensor: 1/2.8" 2.13M pixel CMOS',
              'Resolution: 1920H × 1080V',
              'Minimum illumination: 0LUX (IR on), 0.05LUX (IR off)', 
              'Auto electronic shutter, auto exposure, and auto white balance',
              'IR range: 10–15M',
              'IP rating: IP69K',
              'Compact design and simple installation',
              'Vehicle damping performance optimization'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Signal-to-noise ratio: ≥50dB',
              'Electronic shutter: 1/25s ~ 1/25,000s (auto)',
              'Day/night mode: ICR IR filter',
              'Operating temperature: -40°C to +70°C',
              'Operating humidity: <95% (no condensation)',
              'Power supply: DC12V ±10%',
              'Video output: 1.0VP-P composite, 75Ω, 4PIN aviation cable',
              'Power consumption: 260mA / DC12V ±5%',
              'Dimensions: 2.59 in × 2.29 in × 1.8 in (66mm × 58mm × 46mm)',
              'Weight: 0.39 lbs (180g)'
            ]
          },
          {
            title: 'Lens Options',
            description: '',
            features: [
              '2.2mm M12@ F2.0 (HFOV: 152°, VFOV: 83°, DFOV: 180°)',
              '2.8mm M12@ F2.0 (HFOV: 103°, VFOV: 56°, DFOV: 121°)',
              '3.6mm M12@ F2.2 (HFOV: 88°, VFOV: 49°, DFOV: 103°)'
            ]
          }
        ]
      },
      // {
      //   id: 11,
      //   title: 'FFLITE-POWERBOXMAX',
      //   description: 'FleetFlix Lite dashcam video extension power box with AI capabilities, blind spot detection, and OBD integration.',
      //   brand: 'FleetFlix',
      //   category: 'power',
      //   productLink: 'https://shop.fleethoster.com/products/acc01-lite-pwboxmax',
      //   image: 'product-11',
      //   featured: false,
      //   details: [
      //     {
      //       title: 'Product Description',
      //       description: 'Power Box Max is a FleetFlix Lite dashcam video extension power box that supports the expansion of 4 AHD inputs or 3 AHD inputs plus 1 IPC input. It has AI extension capability and supports left, right, and rear blind spot detection (BSD) audio-visual alarms. It also supports quick power supply from the original vehicle\'s OBD port and OBD data parsing capability. It is commonly used in dashcam products that require vehicle blind spot compensation and cargo monitoring in the scenes of medium and large freight vehicles.',
      //       features: []
      //     },
      //     {
      //       title: 'Key Features',
      //       description: '',
      //       features: [
      //         'Support 3-way IO detection and 1-way iButton access',
      //         'Support 1-way IO output with a current of up to 0.5A',
      //         'Support 3-way RS232, with dedicated ports for R-Watch and B3 devices',
      //         'Powered by OBD with dual CAN channels and multiple protocol support',
      //         'Support 4-way AHD input or 3-way AHD plus 1-way IPC input',
      //         'Support 1-way video output, configurable as AHD or CVBS output',
      //         'Advanced AI detection with 3-way BSD capability'
      //       ]
      //     },
      //     {
      //       title: 'Product Specifications',
      //       description: '',
      //       features: [
      //         'RS232: 3 channels (RS232-1 connects to R-Watch, RS232-2 connects to left B3, RS232-3 connects to right B3)',
      //         'Sensor IN: 3 inputs',
      //         'Sensor OUT: 1 output',
      //         'iButton: 1 channel',
      //         'CAN: 2 channels',
      //         'K-Line: 1 channel (J1708 / J1850 / K-Line — choose one of three)',
      //         'USB: 1× USB 2.0 (Type A), used for local upgrade',
      //         'Operating Temperature: -40°C to +70°C (-40°F to +158°F)',
      //         'Storage Temperature: -40°C to +85°C (-40°F to +185°F)', 
      //         'Working Humidity: 15%–95% (no condensation)',
      //         'LAN: 1 channel, connects to FleetFlix Lite Pro+',
      //         'Video Input: 4 channels AHD or 3 channels AHD + 1 channel IPC',
      //         'Video Output: 1 channel (configurable as AHD or CVBS output)',
      //         'Total Resource: 3 channels ZQOP15 frames + 1 channel ZQOP10 frames',
      //         'BSD Support: Up to 3 channels time-sharing or 2 channels real-time',
      //         'Power Input: DC 9–36V',
      //         'Power Output: 12V @ 2A',
      //         'Standby Power: 24V @ 5mA',
      //         'Dimensions: 192mm × 57mm × 30mm (7.51 in × 2.20 in × 1.18 in)',
      //         'Weight: 554g (19.5 oz)'
      //       ]
      //     }
      //   ]
      // },
      {
        id: 12,
        title: 'Harness 3WOBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-3wobdk',
        image: 'product-12',
        featured: false
      },
      // {
      //   id: 13,
      //   title: 'Harness 4W6POBDK',
      //   description: '',
      //   category: 'harnesses',
      //   productLink: 'https://shop.fleethoster.com/products/hrn01-4w6pobdk',
      //   image: 'product-13',
      //   featured: false
      // },
      {
        id: 14,
        title: 'Harness 4W9POBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-4w9pobdk',
        image: 'product-14',
        featured: false
      },
      {
        id: 15,
        title: 'Harness 4WOBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-4wobdk',
        image: 'product-15',
        featured: false
      },
      {
        id: 16,
        title: 'RZl Al Dash Camera',
        description: 'AI-Driven. Driver Centered. Fleet-Focused. Built for fleets that put lives first—with proactive monitoring, real-time alerts, and driver-first design.',
        brand: 'RoadEazy',
        category: 'cameras',
        productLink: 'https://shop.fleethoster.com/products/rez-rz1-hw',
        image: 'product-16',
        featured: true,
        details: [
          {
            title: 'Features',
            description: '',
            features: [
              'Road-Facing Camera - Captures high-definition footage of the road with wide-angle coverage',
              'Cabin-Facing Camera - Captures a clear view of the driver and in-cabin activity with a color daytime driver-facing camera that can be rotated to be disabled if not wanted',
              'Infrared (IR) LEDs - Enhances low-light and nighttime performance, ensuring clear video recordings in dark environments',
              'Lock/Unlock screw to rotate cameras - Allows precise angle adjustments, ensuring optimal coverage, with secure locking to prevent accidental movement',
              'Driver Alert Button - Enables drivers to manually trigger event recordings for capturing critical moments not automatically detected',
              'Status LEDs - Provides clear visual indicators for power, recording, and operational status at a glance',
              'Speaker and Microphone - Records clear audio to add context to video footage and allows playback of system alerts and prompts (microphone can be disabled)',
              'Safety Events - Every time a safety event occurs based on your fleet\'s customized setup',
              'Live Video - Video is streamed at Standard Definition Quality at 512Mbps and 12 FPS, streamed for 30 seconds by default and can be reset',
              'Streaming Recording Video - Video is streamed as recorded and can be downloaded from player',
              '3M Mounting Pad - Provides secure adhesion to the windshield, ensuring the camera stays in place during vibrations and harsh conditions while being easy to install and reposition'
            ]
          },
          {
            title: 'Specifications',
            description: '',
            features: [
              'Road Facing Camera: 1080p 30FPS with 121° field of view',
              'Driver Facing Camera: 720P, 24fps RGB and IR sensor, 170° field of view with Infrared LED and light sensor',
              'Video Encoding Times (Hours of Recording): Highest 52 Hours | Standard 97 Hours | Increased Storage 175 Hours | Extended Storage 209 Hours',
              'Front Camera Resolution: Highest Quality 1080p | Standard Quality 720p | Increased Storage 720p | Extended Storage 480p',
              'Front Camera Framerate: Highest Quality 24 | Standard Quality 30 | Increased Storage 15 | Extended Storage 15',
              'Front Camera Bitrate (Mbps): Highest Quality 4096 | Standard Quality 2000 | Increased Storage 1000 | Extended Storage 750',
              'Cabin Camera Resolution: Highest Quality 720p | Standard Quality 720p | Increased Storage 720p | Extended Storage 720p',
              'Cabin Camera Framerate: Highest Quality 15 | Standard Quality 15 | Increased Storage 10 | Extended Storage 8',
              'Cabin Camera Bitrate: Highest Quality 1024 | Standard Quality 750 | Increased Storage 512 | Extended Storage 512',
              'Opus Audio Bitrate (Kbps): Highest Quality 20 | Standard Quality 20 | Increased Storage 20 | Extended Storage 20',
              'Front Camera Recording in Mbps: Highest Quality 512 | Standard Quality 250 | Increased Storage 125 | Extended Storage 93.75',
              'Rear Camera Recording in Mbps: Highest Quality 128 | Standard Quality 93.75 | Increased Storage 0.43 | Extended Storage 0.32',
              'Front Camera Recording Hour (GB): Highest Quality 0.44 | Standard Quality 0.32 | Increased Storage 0.22 | Extended Storage 0.22',
              'Rear Camera Recording Hour (GB): Highest Quality 0.44 | Standard Quality 0.32 | Increased Storage 0.22 | Extended Storage 0.22',
              'Audio Recording Hour (GB): Highest Quality 0.0084 | Standard Quality 0.0084 | Increased Storage 0.0084 | Extended Storage 0.0084',
              'Resolution Definitions: 1080p: 1920x1080 | 720p: 1280x720 | 480p: 854x480',
              'Audio: Speaker and Microphone',
              'Push Button: Easy access for driver to generate safety event with video by pushing red button on camera module',
              'LED Indicators: Power (Green) and Safety Alerts (Red)'
            ]
          }
        ]
      },
      {
        id: 17,
        title: 'ATS01-24 Solar Asset Tracker',
        description: 'A compact and stylish solar-powered GPS tracker for monitoring trailers, trucks, containers, and construction equipment with extended battery life and hassle-free installation.',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/ats01-24',
        image: 'product-17',
        featured: false,
        details: [
          {
            title: 'Product Description',
            description: 'Introducing the ATS01-24, a compact and stylish solar-powered GPS tracker meticulously crafted for monitoring various assets, including trailers, trucks, containers, and robust construction equipment. Engineered for durability, this sleek device is your ultimate choice when seeking a resilient, petite, and solar-powered tracker capable of consistent and extended reporting.',
            features: []
          },
          {
            title: 'Key Features',
            description: 'Equipped with a robust solar panel and a dependable backup battery, the ATS01-24 ensures uninterrupted functionality for months on end. Its hassle-free installation eliminates the need for wiring or cabling, making asset tracking effortlessly efficient.',
            features: [
              'Real-time and buffer locations',
              'Rugged and sleek design',
              'IP67 rating (waterproof and dustproof)',
              'Low battery and removal alerts',
              'Rechargeable battery',
              'BLE 5.3 for sensor compatibility',
              'Solar powered'
            ]
          },
          {
            title: 'Product Specifications',
            description: '',
            features: [
              'Dimensions: 3.4 × 2.37 × 1.20 inches (88 × 60.4 × 30.7 mm)',
              'Weight: 5.3 oz (150 g)',
              'Operating Temperature: −22°F to 176°F (−30°C to +80°C)',
              'IP Rating: IP67 (waterproof and dustproof)',
              'Installation Methods: Magnets, screw mounting options, double-sided tape',
              'Bluetooth Version: BLE 5.3',
              'Battery: Rechargeable Li-Polymer, 2500 mAh / 3.6V',
              'Connectivity: LTE Cat-M1',
              'Supported Bands: B1, B2, B3, B4, B5, B8, B12, B13, B18, B19, B20, B26, B28A/B28B, B66, B71, B85',
              'Indicators: Network, GNSS, Battery',
              'Alerts: Tamper, Low Battery, Geo-Fence'
            ]
          }
        ]
      },
      {
        id: 18,
        title: 'ATS01-CL120 Solar Cargo Lock Asset Tracker',
        description: 'Solar-powered GPS tracker with integrated E-lock system for securing and monitoring cargo containers, trailers, and trucks with remote locking capabilities.',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/ats01-cl120',
        image: 'product-18',
        featured: false,
        details: [
          {
            title: 'Product Description',
            description: 'The Solar GPS Cargo Lock Asset Tracker is designed for outdoor equipment monitoring within telematics systems. It is ideal for tracking and securing assets such as containers, trailers, and trucks. The device features high-efficiency solar charging and a long-lasting battery.',
            features: []
          },
          {
            title: 'Remote Control Features',
            description: 'This solar-powered E-lock sends alerts to the server for key events such as rope cutting, locking, and unlocking. The device can be unlocked remotely or in close proximity using RFID, BLE, or network and SMS commands.',
            features: []
          },
          {
            title: 'Key Features',
            description: '',
            features: [
              'Built-in strong magnet',
              'BLE 5.0 connectivity',
              'IP67 rugged design',
              '14,400mAh rechargeable battery',
              'Alerts for locking, unlocking, rope-cutting, and motion',
              'Native Geotab integration'
            ]
          },
          {
            title: 'Product Specifications',
            description: '',
            features: [
              'Dimensions - 8.17 × 4.39 × 1.91 in (207.5 × 110.2 × 48.1 mm)',
              'Weight - 37 oz (1050 g)',
              'Operating Temperature - −13°F to 176°F (−25°C to +80°C)',
              'IP Rating - IP67 (waterproof and dustproof)',
              'Installation - Built-in magnet',
              'Bluetooth - Optional BLE 5.1 connectivity',
              'Charging - Solar panel and customized USB cable',
              'Connectivity - LTE FDD Cat M1',
              'Supported Bands - B1, B2, B3, B4, B5, B8, B12, B13, B18, B19, B20, B25, B26, B27, B28, B66, B85',
              'Alerts - Locking, unlocking, rope-cutting, motion',
              'LED Indication - Network, GNSS, RFID, Battery',
              'Rope Length - 400 mm (standard)'
            ]
          }
        ]
      },
      {
        id: 19,
        title: 'ATW01-4 Asset Tracker',
        description: 'Rugged, weatherproof asset tracker with battery backup and BLE sensor support for comprehensive asset monitoring.',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/atw01-4',
        image: 'product-19',
        featured: false,
        details: [
          {
            title: 'Product Description', 
            description: 'The ATW01-4 is rugged, weatherproof, and designed to provide robust tracking for various asset types that occasionally or always have a power source. It includes an internal battery backup that can ping for up to 4 months between recharges.',
            features: []
          },
          {
            title: 'Installation',
            description: 'Installation is simple and expandable, with support for ignition and other input reporting, including wireless BLE sensors. These sensors are ideal for tracking temperatures, tools, small equipment, and more. This device is perfect for trailers, construction equipment/vehicles, or any asset that needs frequent reporting or additional inputs.',
            features: []
          },
          {
            title: 'Key Hardware Features',
            description: '',
            features: [
              'Variable reporting intervals with real-time updates several times a day',
              'Can buffer up to 60,000 location points when out of network coverage',
              'Rugged and weatherproof for outdoor use',
              'Compatible with wiring relay, buzzer, and siren for vehicle immobilization (anti-theft)',
              'BLE 5.0 support for wireless sensor monitoring (e.g., Cold Chain, tool tracking)',
              'Fully integrated into Geotab'
            ]
          },
          {
            title: 'Product Specifications',
            description: '',
            features: [
              'Dimensions - 132 mm × 100 mm × 34 mm (5.2 in × 3.93 in × 1.34 in)',
              'Weight - 320 g (11.3 oz)',
              'Operating Temperature - −25°C to +70°C (−13°F to +158°F)',
              'Battery - Rechargeable Li-ion, 9600 mAh / 3.6V',
              'Alerts/Sensors - BLE 5.0; IP65',
              'IP/Ingress Rating - IP67',
              'Mounting/Installation Options - Magnet / Zip-tie / Screws',
              'Network Connectivity - 4G LTE Cat M1',
              'Supported Bands - B1, B2, B3, B4, B5, B8, B12, B13, B18, B19, B20, B25, B28, B39'
            ]
          }
        ]
      },
      // {
      //   id: 20,
      //   title: 'FFLITE-POWERBOXPLUS',
      //   description: 'Advanced OBD interface device supporting multiple protocols for diesel commercial vehicles with comprehensive IO and CAN capabilities.',
      //   category: 'power',
      //   image: 'product-20',
      //   featured: false,
      //   details: [
      //     {
      //       title: 'Product Description',
      //       description: 'Power Box Plus uses the OBD interface to connect to the vehicle. It supports J1939, J1850, and J1708 protocols, and outputs data to the host system via the serial port after analysis. This device is ideal for diesel commercial vehicles such as heavy trucks, box trucks, and pickups.',
      //       features: []
      //     },
      //     {
      //       title: 'Product Features',
      //       description: '',
      //       features: [
      //         'Supports 3-way IO detection',
      //         'Supports 1 channel RS232 with 12V output (current up to 0.5A)',
      //         'Supports 2-way CAN',
      //         'Supports J1939 protocol',
      //         'Supports J1708 / J1850 / K-Line protocol (choose one of three)',
      //         'Supports 1 channel iButton access'
      //       ]
      //     },
      //     {
      //       title: 'Product Specifications',
      //       description: '',
      //       features: [
      //         'RS232: 1 channel',
      //         'Sensor IN: 3 inputs',
      //         'iButton: 1 channel', 
      //         'CAN: 2 channels',
      //         'K-Line: 1 channel (J1708 / J1850 / K-Line — choose one)',
      //         'Power Input: DC 9–36V',
      //         'Power Output: 12V @ 500mA',
      //         'Standby Power Consumption: 24V @ 5mA',
      //         'Size: 86 mm × 78 mm × 27 mm (3.3 in × 3 in × 1.1 in)',
      //         'Weight: 85 g (3 oz)',
      //         'Operating Temperature: −40°C to +70°C (−40°F to +158°F)',
      //         'Working Humidity: 8%–95% (no condensation)'
      //       ]
      //     }
      //   ]
      // },
      {
        id: 21,
        title: 'LL303 Solar GPS Tracker',
        description: 'A cutting-edge 4G GPS tracker powered by solar energy, designed for managing construction vehicles, containers, and trailers.',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/ats06-ll303',
        image: 'product-21',
        featured: false,
        details: [
          {
            title: 'Product Description',
            description: 'The LL303 is a cutting-edge 4G GPS tracker powered by solar energy, designed for managing construction vehicles, containers, and trailers. This device ensures continuous power through solar charging, eliminating the need for frequent recharging. It is ideal for long-term, reliable operation in harsh environments.',
            features: []
          },
          {
            title: 'Key Features',
            description: '',
            features: [
              'Powerful solar panel for continuous charging',
              'Magnetic charging capability',
              'IP67 waterproof and rugged design',
              'Solar and magnetic charging options',
              'Low battery, tamper, and vibration alerts',
              '10,000 mAh battery capacity',
              'Optional BLE 5.0 connectivity',
              'Native Geotab integration'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Dimensions: 8.0 × 4.8 × 1.3 inches (203 × 122 × 33 mm)',
              'Weight: 19.33 oz (548 g)',
              'Operating Temperature: −4°F to 158°F (−20°C to +70°C)',
              'IP Rating: IP67 (waterproof and dustproof)',
              'Solar Power Input: 5V / 400mA',
              'Bluetooth: Optional BLE 5.0 connectivity',
              'Battery: 10,000 mAh / 3.7V Industrial-grade Li-Polymer rechargeable',
              'Connectivity: LTE Cat M1',
              'Supported Bands: B2, B4, B5, B12, B13, B25, B26, B66',
              'Alerts: Low battery, tamper, vibration',
              'LED Indicators: Cellular (Green), Power (Red)'
            ]
          }
        ]
      },
      {
        id: 22,
        title: 'DCA01-SC Auxiliary Side Camera',
        description: 'An auxiliary side camera designed to enhance fleet security and visibility with HD resolution and night vision capabilities.',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-sc',
        image: 'product-22',
        featured: false,
        details: [
          {
            title: 'Product Description',
            description: 'The DCA01-SC is an auxiliary side camera designed to enhance fleet security and visibility. This camera is ideal for capturing side views of vehicles, improving situational awareness and safety during fleet operations.',
            features: [
              '1080p HD resolution',
              'Night vision capabilities',
              'Rugged design',
              'Compatibility with FleetFlix AI+ and SurfSight AI-12 systems'
            ]
          },
          {
            title: 'Hardware Features',
            description: '',
            features: [
              'IP66-rated durability for outdoor use',
              'Expandable coverage with support for up to 4 auxiliary cameras',
              'Optional magnetic mounts for easy installation',
              'Customizable event triggers for specific scenarios',
              'Automated event uploads to a server',
              'Seamless integration into Geotab'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Tech Available: Live stream, Dual IR, 1080p, Nighttime view',
              'Video Availability: Live stream, Event-based',
              'Input Voltage: 12V, 2 amp',
              'Operating Temperature: −10°C to +85°C',
              'Installation Methods: Hardwire powered',
              'Video: Road capture in HD 1080p',
              'IP Rating: IP66 (dust-tight and protected against powerful water jets)'
            ]
          }
        ]
      },
      {
        id: 23,
        title: '7-inch HD Fleet Monitor',
        description: 'High-definition 7-inch monitor designed for fleet vehicles, featuring dual-channel support, IPS display, and rugged construction for enhanced driver visibility and safety.',
        category: 'monitor',
        productLink: 'https://shop.fleethoster.com/products/acc01-lite-mon-7hd',
        image: 'product-23',
        featured: true,
        details: [
          {
            title: 'Product Description',
            description: 'The 7-inch high-definition monitor enhances the driver\'s ability to observe vehicle operations and the surrounding environment clearly, improving both safety and efficiency. With simple button operation, high resolution and brightness, high contrast, and wide viewing angle, this monitor is suitable for various driving scenarios, improving the driving experience and vehicle operating efficiency.',
            features: []
          },
          {
            title: 'Features',
            description: '',
            features: [
              'Dual-channel support with 2 video inputs and dual/single image segmentation display',
              'IPS screen with fast response speed, wide viewing angle, and true color (1024 RGB × 600 resolution)',
              'OSD menu for mirror/normal image settings, delay time configuration, and trigger priority management',
              'Rugged design with high-temperature resistant ABS + PC materials',
              'Removable sun hat to reduce glare from direct sunlight',
              'Rust-proof metal bracket with U-shaped double-sided fastening and anti-vibration design',
              'High brightness of 600 cd/㎡ for clear image visibility',
              'Load dump pulse voltage protection (DC 24V + 174V for 350 ms)',
              'Energy-efficient power supply with low-temperature stability',
              'Wide voltage range operation (DC 11–32V)',
              'Built-in reverse polarity protection with LED thermal response'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Screen Size: 7 inches (177 mm)',
              'Color System: AHD 720P / 1080P',
              'Display Resolution: 1024 RGB(H) × 600(V)',
              'Viewable Area: 154.4 mm × 85.9 mm',
              'Brightness: 600 cd/㎡',
              'Contrast Ratio: 700:1',
              'Viewing Angle: 160° / 160°',
              'LED Power: 8.7V / 220mA',
              'Maximum Power Consumption: 5W',
              'Operating Voltage: DC 11–32V',
              'Operating Temperature: −20°C to +70°C (−4°F to +158°F)',
              'Storage Temperature: −30°C to +80°C (−30°F to +176°F)',
              'Motherboard Chipset: ATM630M',
              'Power Output: DC 10.5V / 750mA',
              'Dimensions: 8.5 in × 5.9 in × 3.3 in (216 mm × 150 mm × 85 mm)',
              'Net Weight: 28.2 oz (800 g)'
            ]
          }
        ]
      },
    ]
  },

  blog: {
    title: 'Geotab Partner Blog',
    subtitle: 'Latest News and Insights',
    description: 'Stay informed with the fleet management technology and industry best practices.',
  },
  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'Official Geotab Partner | Fleet Tracking & Telematics',
    description: 'Geotab Partner store for fleet management solutions and accessories with wide selection, best prices, and fast shipping.',
    keywords: [
      'Geotab partner', 'fleet equipment', 'fleet accessories', 'fleet store', 'fleet technology', 'fleet management',
      'Geotab fleet store', 'fleet equipment store', 'fleet accessories store', 'fleet technology store', 'fleet management store',
      'fleet equipment hub', 'fleet technology solutions', 'fleet accessories hub', 'fleet management solutions',
      'fleet store solutions', 'fleet technology hub', 'fleet equipment solutions', 'fleet management hub'
    ],
    
    // Open Graph & Social Media
    ogTitle: 'Geotab Partner - Your Fleet Partner',
    ogDescription: 'Complete fleet management solutions and accessories store. Wide selection, best prices, fast shipping.',
    ogType: 'website',
    ogUrl: 'https://www.geotabpartner.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'Geotab Partner - Your Fleet Partner',
    twitterDescription: 'Complete fleet management solutions and accessories store. Wide selection, best prices, fast shipping.',
    
    // Robots
    robots: 'index, follow',
    author: 'Geotab Partner',
    publisher: 'Geotab Partner',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'Official Geotab Partner | Fleet Tracking & Telematics',
        description: 'Geotab Partner store for fleet management solutions and accessories with wide selection, best prices, and fast shipping.',
        keywords: ['Geotab partner', 'fleet equipment', 'fleet accessories', 'fleet store', 'fleet technology']
      },
      solutions: {
        title: 'Geotab Fleet Management Solutions | Geotab Partner',
        description: 'Geotab Partner fleet equipment solutions with professional services, wide selection, best prices, and expert support for fleets.',
        keywords: ['fleet equipment solutions', 'fleet store services', 'equipment services', 'fleet support']
      },
      products: {
        title: 'Buy Geotab GO Devices & Dash Cams | Geotab Partner',
        description: 'Professional fleet equipment products and accessories. Wide selection, best prices, and fast shipping.',
        keywords: ['fleet equipment products', 'fleet accessories', 'fleet store products', 'fleet technology equipment']
      },
      blog: {
        title: 'Fleet Management Blog by Certified Geotab Partner',
        description: "Stay updated with Geotab Partner news, insights, and best practices for fleet equipment and technology, plus professional tips.",
        keywords: ['fleet equipment news', 'fleet store insights', 'equipment best practices', 'fleet technology tips']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
